<template>
  <div class="artist-profile__empty-biography">
    <img style="width: 361px" :src="'/res7/img/placeholders/'+name_+'.svg'" :alt="name"/>

    <p class="artist-profile__empty-biography-text" v-if="text_html" v-html="text_html"/>

    <slot name="action"/>
  </div>
</template>

<script>
//см themes/_models/placeholders/show.xsl

  export default {
    name: 'placeholder8',
    props: {
      name: {type: String, default:''},
      text_html: {type: String, default:''},
    },

    computed: {
      name_: {
        get() {
          let tmp = this.name;

          switch (tmp) {
            case 'artist':
              tmp='collection';
            break;
            case 'info':
              tmp='messages';
            break;
            case 'article':
              tmp='confirmation';
            break;
            case 'gallery':
              tmp='friends';
            break;
            case 'work':
              tmp='collection';
            break;
            case 'clients':
              tmp='deal';
            break;
          }

          return tmp;
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lib/placeholder8.vue